
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 16.694c-.067 0-.133 0-.2-.066l-8.667-8A.505.505 0 010 8.36c0-.067.067-.2.133-.267l8.667-8c.067-.066.267-.133.333-.066.134.066.2.2.2.333v5c1.2 0 5.134.267 7.867 3 1.867 1.8 2.8 4.267 2.8 7.333 0 .134-.133.334-.267.334-.133 0-.333-.067-.4-.267-1.2-4.133-8.4-4.4-10-4.4v5a.367.367 0 01-.2.333H9zM.8 8.361l7.867 7.267v-4.6c0-.2.133-.334.333-.334.333 0 7.6-.133 10.267 3.4-.267-2.2-1.067-3.933-2.467-5.266-3-2.934-7.733-2.8-7.733-2.8-.067 0-.2 0-.267-.067a.505.505 0 01-.133-.267v-4.6L.8 8.361z"}})])
          )
        }
      }
    